module.exports = __webpack_public_path__ + "img/map.35605258.jpg";